import { Factory } from 'miragejs'

export default Factory.extend({
  menuId: 11220,
  menuName(i) {
    return `IKEA UK July 13 2018 #${i + 1}`
  },
  menuDescription: null,
  locationId: 10136,
  itemId: 11582093,
  itemName: 'Italian Meat Feast Hero',
  timeRemoved: null
})
